export default __webpack_public_path__ + "locales/ja-JP/UploadPanel.json?hash=725b41eee395f8fefcb6b729e272b6f2";